import {pathMatchesPrefix} from "./navItem";

/** Comfortable tab label size on a full-width desktop bar. */
export const MAIN_NAV_MAX_FONT_PX = 16;

/** Minimum still-readable tab label size (MINSKY-16738). */
export const MAIN_NAV_MIN_FONT_PX = 12;

/**
 * Viewport at or below this width uses the hamburger instead of tabs.
 * 1280px is the first common width where a 12px analyst tab row plus Admin /
 * AuthSelect still collides. 1536 CSS px (1920×1080 @ 125%) stays on tabs.
 */
export const MAIN_NAV_BURGER_MAX_WIDTH_PX = 1279;

export const MAIN_NAV_BURGER_MEDIA_QUERY = `(max-width:${MAIN_NAV_BURGER_MAX_WIDTH_PX}px)`;

/** 16px at ≥~1778px; ~13.8px at 1536px; 12px at ≤~1333px. */
export const MAIN_NAV_TAB_FONT_SIZE = `clamp(${MAIN_NAV_MIN_FONT_PX}px, 0.9vw, ${MAIN_NAV_MAX_FONT_PX}px)`;

export function destinationPath(destination) {
    if (!destination) return '';
    const withoutQuery = destination.split('?')[0];
    return withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
}

export function isMainNavItemActive(pathname, item) {
    if (Array.isArray(item.activePrefixes) && item.activePrefixes.length > 0) {
        return item.activePrefixes.some((prefix) => pathMatchesPrefix(pathname, prefix));
    }
    return pathMatchesPrefix(pathname, destinationPath(item.destination));
}
